import { api } from '@/config/api';

export type TaskStatus = 'open' | 'in_progress' | 'done' | 'cancelled';
export type TaskPriority = 'low' | 'normal' | 'high' | 'urgent';
export type TaskEntityType = 'contact' | 'deal' | 'lead';
export type TaskRecurrenceFrequency = 'daily' | 'weekly' | 'monthly' | 'yearly';

export interface TaskRecurrence {
  frequency: TaskRecurrenceFrequency;
  interval?: number;
  endDate?: string;
}

export interface Task {
  _id: string;
  taskUid: string;
  companyUid: string;
  entityType?: TaskEntityType;
  entityUid?: string;
  title: string;
  description?: string;
  status: TaskStatus;
  priority: TaskPriority;
  assigneeUserUid?: string;
  createdByUserUid: string;
  dueAt?: string;
  completedAt?: string;
  reminderSent: boolean;
  reminderMinutesBefore?: number;
  recurrence?: TaskRecurrence;
  recurrenceSeriesUid?: string;
  createdAt: string;
  updatedAt: string;
}

const BASE = '/slighter_crm/tasks';

export const tasksService = {
  list: async (params: {
    status?: string; assigneeUserUid?: string;
    entityType?: TaskEntityType; entityUid?: string;
    from?: string; to?: string;
  } = {}): Promise<Task[]> => (await api.get(BASE, { params })).data,

  mine: async (): Promise<Task[]> => (await api.get(`${BASE}/mine`)).data,

  dueToday: async (mineOnly = true): Promise<Task[]> =>
    (await api.get(`${BASE}/due-today`, { params: { mineOnly: mineOnly ? '1' : '0' } })).data,

  overdue: async (mineOnly = true): Promise<Task[]> =>
    (await api.get(`${BASE}/overdue`, { params: { mineOnly: mineOnly ? '1' : '0' } })).data,

  get: async (uid: string): Promise<Task> => (await api.get(`${BASE}/${uid}`)).data,

  create: async (payload: {
    title: string; description?: string;
    status?: TaskStatus; priority?: TaskPriority;
    assigneeUserUid?: string; dueAt?: string;
    entityType?: TaskEntityType; entityUid?: string;
    reminderMinutesBefore?: number;
    recurrence?: TaskRecurrence;
  }): Promise<Task> => (await api.post(BASE, payload)).data,

  update: async (uid: string, payload: Partial<Task>): Promise<Task> =>
    (await api.patch(`${BASE}/${uid}`, payload)).data,

  remove: async (uid: string): Promise<{ ok: boolean }> => (await api.delete(`${BASE}/${uid}`)).data,
};
